export default function ContactSection() {

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          {/* Left - contact info */}
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">
              Kontakt
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
              Skontaktuj się ze mną
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-8">
              Masz pytania? Chcesz umówić bezpłatną konsultację? Jestem do Twojej dyspozycji. Odpowiem na każde zapytanie i pomogę rozwiać wątpliwości.
            </p>

            <div className="flex flex-col gap-5">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 shrink-0">
                  <i className="ri-phone-line text-accent-500 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide mb-1">Telefon</p>
                  <a
                    href="tel:698084044"
                    className="text-lg font-semibold text-foreground-800 hover:text-primary-500 transition-colors"
                  >
                    698 084 044
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 shrink-0">
                  <i className="ri-mail-line text-accent-500 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide mb-1">E-mail</p>
                  <a
                    href="mailto:biuro@kredytpodkarpacie.pl"
                    className="text-lg font-semibold text-foreground-800 hover:text-primary-500 transition-colors"
                  >
                    biuro@kredytpodkarpacie.pl
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 shrink-0">
                  <i className="ri-map-pin-line text-accent-500 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide mb-1">Adres biura</p>
                  <p className="text-lg font-semibold text-foreground-800">
                    38-500 Sanok, ul. Dworcowa 11A
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 shrink-0">
                  <i className="ri-global-line text-accent-500 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide mb-1">Strona internetowa</p>
                  <p className="text-lg font-semibold text-foreground-800">
                    kredytpodkarpacie.pl
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - CTA card */}
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-background-200/60 shadow-sm">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              Bezpłatna konsultacja
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              Umów się na bezpłatną, niezobowiązującą konsultację. Przeanalizuję Twoją sytuację i przedstawię dostępne możliwości.
            </p>

            <div className="flex flex-col gap-3 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                  <i className="ri-check-line text-accent-500 text-xs" />
                </div>
                <span className="text-sm text-foreground-700">Bezpłatna i niezobowiązująca</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                  <i className="ri-check-line text-accent-500 text-xs" />
                </div>
                <span className="text-sm text-foreground-700">Osobiście, telefonicznie lub online</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                  <i className="ri-check-line text-accent-500 text-xs" />
                </div>
                <span className="text-sm text-foreground-700">Analiza Twojej sytuacji</span>
              </div>
            </div>

            <a
              href="tel:698084044"
              className="inline-flex justify-center w-full px-6 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors shadow-md whitespace-nowrap cursor-pointer"
            >
              Zadzwoń – umów konsultację
            </a>

            <p className="text-xs text-foreground-500 text-center mt-4">
              Odpowiadam w ciągu 24 godzin
            </p>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="px-4 md:px-8 lg:px-12 mt-10 lg:mt-14">
        <div className="w-full h-[250px] md:h-[350px] rounded-2xl overflow-hidden border border-background-200/60 shadow-sm">
          <iframe
            title="EXPERT KREDYTOWY – ul. Dworcowa 11A, Sanok"
            src="https://maps.google.com/maps?q=ul.+Dworcowa+11A,+38-500+Sanok,+Polska&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
